<template lang="html">
  <div class="container-fluid p-1 p-lg-5 mt-3">
    <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h6>
              <button class="back-btn" type="button" @click="back()">
                <i class="fas fa-arrow-left"></i>
              </button>
              Edit Banner
            </h6>
          </div>
          <div class="card-body">
            <form @submit.prevent="onSubmit">
              <div class="form-group">
                <label>Title <span class="text-danger">*</span></label>
                <input
                  type="text"
                  class="form-control"
                  v-model="bannerRequest.title"
                />
                <small class="text-danger">{{ validationData.title }}</small>
              </div>
              <div class="form-group">
                <label>Banner Image <span class="text-danger">*</span></label>

                <input
                  type="file"
                  class="form-control"
                  accept="image/*"
                  @change="readBannerImage"
                />

                <small class="text-danger">{{
                  validationData.banner_image
                }}</small>
                <div v-if="bannerImage" class="mt-2">
                  <img :src="bannerImage" class="banner-image" />
                </div>
              </div>

              <div class="form-group">
                <label>Detail Image <span class="text-danger">*</span></label>

                <input
                  type="file"
                  class="form-control"
                  accept="image/*"
                  @change="readDetailImage"
                />

                <small class="text-danger">{{
                  validationData.detail_image
                }}</small>
                <div v-if="detailImage" class="mt-2">
                  <img :src="detailImage" class="banner-image" />
                </div>
              </div>

              <div class="form-group">
                <label>Body <span class="text-danger">*</span></label>
                <vue-editor v-model="bannerRequest.description" />
                <small class="text-danger">{{
                  validationData.description
                }}</small>
              </div>

              <div class="form-group">
                <label>Redirect</label><br />
                <label class="switch">
                  <input type="checkbox" v-model="bannerRequest.redirect" />
                  <span class="slider"></span>
                </label>
              </div>

              <div class="form-group" v-if="bannerRequest.redirect">
                <label>Redirect Type</label>
                <select
                  class="form-control"
                  v-model="bannerRequest.redirect_type"
                  :value="bannerRequest.redirect_type"
                >
                  <option disabled value="">Select redirect page</option>
                  <option value="referral_page">Referral Page</option>
                </select>
                <small class="text-danger">{{
                  validationData.redirect_type
                }}</small>
              </div>

              <div class="form-group">
                <label>Status</label><br />

                <label class="switch">
                  <input type="checkbox" v-model="bannerRequest.status" />
                  <span class="slider"></span>
                </label>

                <small class="text-muted">
                  {{ bannerRequest.status ? "Active" : "Inactive" }}
                </small>
              </div>

              <small class="text-danger">{{
                validationData.serverError
              }}</small>

              <button type="submit" class="btn btn-primary float-save">
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="js">
    import {
        mapActions
    } from 'vuex'
import env from '../../enviorments'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css';
import {
    VueEditor
} from 'vue2-editor'

export default {
    name: 'bannerEdit',
    metaInfo: {
        title: "Banner",
        titleTemplate: "%s ← New",
    },
    components: {
        Loading,
        VueEditor,
    },
    data() {
        return {
            env,
            isLoading: false,
            fullPage: true,
            bannerImage:null,
            detailImage:null,
            filter: {
                page: "",
                status:true
            },
            bannerRequest: {
				        id:'',
                title: '',
                description:"",
                banner_image:null,
                detail_image:null,
                redirect:false,
                redirect_type:"",
				        status:false,

            },
            validationData: {
                title: '',
                description:'',
                banner_image:'',
                detail_image:'',
                redirect_type:""

            }
        }
    },
    watch: {
        async $route(to, from) {},
    },
    computed: {},
    methods: {
        ...mapActions({
            bannerEditAction: 'bannerEditAction',
            bannerDetailAction: 'bannerDetailAction',
        }),

	 async getDetails() {
            let option = {
                id: this.bannerRequest.id
            }
            await this.bannerDetailAction({
                ...option
            }).then(res => {
              this.bannerRequest.title = res.data.title;
              this.bannerRequest.description = res.data.description;
				      this.bannerRequest.status = res.data.status;
				      this.bannerImage = res.data.banner_image;
				      this.detailImage = res.data.detail_image;
				      this.bannerRequest.banner_image = res.data.banner_image;
				      this.bannerRequest.detail_image = res.data.detail_image;
              this.isLoading = false;
              this.bannerRequest.redirect = !!res.data.redirect_page
              this.bannerRequest.redirect_type = res.data.redirect_page
            }).catch(err => this.isLoading = true)
        },

      async readBannerImage(event) {
  const file = event.target.files[0];

  if (!file) return;

  // store file for submit
  this.bannerRequest.banner_image = file;

  // preview
  const fileReader = new FileReader();
  fileReader.readAsDataURL(file);
  fileReader.onload = e => {
    this.bannerImage = e.target.result;
  };

  this.validationRule();
},
 async readDetailImage(event) {
  const file = event.target.files[0];

  if (!file) return;

  // store file for submit
  this.bannerRequest.detail_image = file;

  // preview
  const fileReader = new FileReader();
  fileReader.readAsDataURL(file);
  fileReader.onload = e => {
    this.detailImage = e.target.result;
  };

  this.validationRule();
},
        async onSubmit() {
            this.isLoading = true
            let validation = this.validationRule()
            if (validation == true) {
                this.isLoading = false
                return
            }

            const formData = new FormData();
			formData.append("_method", "PUT");
			 formData.append("id", this.bannerRequest.id);
            formData.append("title", this.bannerRequest.title);
			if(typeof this.bannerRequest.banner_image !=="string"){
            formData.append("banner_image",this.bannerRequest.banner_image);
			}
			if(typeof this.bannerRequest.detail_image !== "string"){
            formData.append("detail_image",this.bannerRequest.detail_image);
			}
            formData.append("description", this.bannerRequest.description);
			formData.append("status", this.bannerRequest.status === true ? 1 : 0);

            await this.bannerEditAction(
                formData
            ).then(res => {
                if (res.success === true) {
                    this.back()
                    this.isLoading = false;
                } else {
					this.isLoading = false;
					this.validationData.serverError = res.message;
					setTimeout(() => {
						this.validationData.serverError = "";
					},3000)
                }
            }).catch(err => this.isLoading = false)
        },
        back() {
            this.$router.replace({
                path: 'banner-list',
                query: {
                page: 10,
                status:this.filter.status,
                orderBy: "asc",
                sortKey: "created_at",
                }
            }).catch(() => {})
        },
        validationRule() {
            let isValidation = []
            if (this.bannerRequest.title == "") {
                this.validationData.title = "The title field is required."
                isValidation.push(true)
            } else {
                this.validationData.title = ""
                isValidation.push(false)
            }

            if(!this.bannerRequest.banner_image){
                this.validationData.banner_image = "Banner Image is required."
                isValidation.push(true)
            }else{
                this.validationData.banner_image = ""
                isValidation.push(false)
            }

            if(!this.bannerRequest.detail_image){
                this.validationData.detail_image = "Detail Image is required."
                isValidation.push(true)
            }else{
                this.validationData.detail_image = ""
                isValidation.push(false)
            }


            if (this.bannerRequest.description == "") {
                this.validationData.description = "Description field is required."
                isValidation.push(true)
            } else {
                this.validationData.description = ""
                isValidation.push(false)
            }
            if (isValidation.includes(true)) {
                return true
            } else {
                return false
            }
        },
    },
    async mounted() {
		 this.filter.page = this.$route.query.page
        this.filter.orderBy = this.$route.query.orderBy
        this.filter.sortKey = this.$route.query.sortKey
        this.bannerRequest.id = this.$route.query.id
        this.filter.status = this.$route.query.status
        this.filter.title = this.$route.query.title
        this.filter.from_date = this.$route.query.from_date
        this.filter.to_date = this.$route.query.to_date
        this.getDetails()
	}
}
</script>

<style scoped lang="scss">
.v-text-field--box .v-input__slot,
.v-text-field--outline .v-input__slot {
  min-height: 56px;
}
.banner-image {
  width: 400px;
  height: 150px;
  object-fit: cover;

  border-radius: 12px;
}
</style>
